import styled from 'styled-components';

export const Title = styled.span`
  font-size: 1em;
  font-weight: 700;
`;
